import { render, staticRenderFns } from "./ComplaintTypeUpdate.vue?vue&type=template&id=150ddc5c&"
import script from "./ComplaintTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports